import { createContext } from 'react'

const WorkspaceContext = createContext(null)

export default WorkspaceContext
